import { faUser } from "@fortawesome/free-solid-svg-icons";
import { reduce, isPositiveNumber } from "et3-type-guards";
import React from "react";
import i18n from "../../../../constants/i18n";
import getQAStore from "../../../../stores/qa";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3DateTime from "../../../../core/et3-input/et3-date-time";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import ET3Div from "../../../../core/et3-div";

const ChangeStatusForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const userID = reduce(() => getQAStore().statusUserID.get(), -1);
  const allowToChangeDate = isPositiveNumber(userID);
  const changedStatusDate = reduce(
    () => getQAStore().changedStatusDate.get(),
    new Date()
  );

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          icon={faUser}
          type={"number"}
          label={i18n.get("USER_ID")}
          placeHolder={i18n.get("USER_ID")}
          onChoose={(value: number) => {
            getQAStore().setStatusUserID(value);
          }}
          onBlur={() => {}}
          value={userID}
          style={{}}
          onEnter={() => {
            getQAStore().changeStatus();
          }}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3DateTime
          selectedDate={changedStatusDate}
          onChange={(date: any) => {
            let newDate = new Date(date.toLocaleString());
            getQAStore().changedStatusDate.set(newDate);
          }}
          label={i18n.get("QA_NEW_STATUS_DATE")}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={allowToChangeDate}
        onClick={async () => await getQAStore().changeStatus()}
        type="APPROVE"
        size="LARGE"
        text="QA_CHANGE_STATUS_DATE"
      />
    </React.Fragment>
  );
});

export default ChangeStatusForm;
